import React from "react";
import Image from "../assets/img/house-banner.png";

const Banner = () => {
  return (
      <div className="mb-6 pt-6 mt-10 xl:ml-[175px] flex flex-col items-center lg:items-start ">
        <h1 className=" lg:text-[38px] font-semibold leading-none mb-6">
          Search properties to rent
        </h1>
      </div>
  );
};

export default Banner;
